// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/connector/v2/resource.proto" (package "c1.connector.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../../google/protobuf/struct";
import { Any } from "../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.connector.v2.ResourceType
 */
export interface ResourceType {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.ResourceType.Trait traits = 3
     */
    traits: ResourceType_Trait[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 4
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string description = 5
     */
    description: string;
    /**
     * @generated from protobuf field: bool sourced_externally = 6
     */
    sourcedExternally: boolean;
}
/**
 * @generated from protobuf enum c1.connector.v2.ResourceType.Trait
 */
export enum ResourceType_Trait {
    /**
     * @generated from protobuf enum value: TRAIT_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: TRAIT_USER = 1;
     */
    USER = 1,
    /**
     * @generated from protobuf enum value: TRAIT_GROUP = 2;
     */
    GROUP = 2,
    /**
     * @generated from protobuf enum value: TRAIT_ROLE = 3;
     */
    ROLE = 3,
    /**
     * @generated from protobuf enum value: TRAIT_APP = 4;
     */
    APP = 4,
    /**
     * @generated from protobuf enum value: TRAIT_SECRET = 5;
     */
    SECRET = 5,
    /**
     * @generated from protobuf enum value: TRAIT_SECURITY_INSIGHT = 6;
     */
    SECURITY_INSIGHT = 6,
    /**
     * @generated from protobuf enum value: TRAIT_SCOPE_BINDING = 7;
     */
    SCOPE_BINDING = 7
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceTypesServiceListResourceTypesRequest
 */
export interface ResourceTypesServiceListResourceTypesRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource parent = 1
     */
    parent?: Resource;
    /**
     * @generated from protobuf field: uint32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 4
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string active_sync_id = 5
     */
    activeSyncId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceTypesServiceListResourceTypesResponse
 */
export interface ResourceTypesServiceListResourceTypesResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.ResourceType list = 1
     */
    list: ResourceType[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.CreateResourceRequest
 */
export interface CreateResourceRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1
     */
    resource?: Resource;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateResourceResponse
 */
export interface CreateResourceResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource created = 1
     */
    created?: Resource;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.DeleteResourceRequest
 */
export interface DeleteResourceRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 1
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2
     */
    parentResourceId?: ResourceId;
}
/**
 * @generated from protobuf message c1.connector.v2.DeleteResourceResponse
 */
export interface DeleteResourceResponse {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.DeleteResourceV2Request
 */
export interface DeleteResourceV2Request {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 1
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2
     */
    parentResourceId?: ResourceId;
}
/**
 * @generated from protobuf message c1.connector.v2.DeleteResourceV2Response
 */
export interface DeleteResourceV2Response {
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 1
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.RotateCredentialRequest
 */
export interface RotateCredentialRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 1
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialOptions credential_options = 2
     */
    credentialOptions?: CredentialOptions;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptionConfig encryption_configs = 3
     */
    encryptionConfigs: EncryptionConfig[];
}
/**
 * @generated from protobuf message c1.connector.v2.RotateCredentialResponse
 */
export interface RotateCredentialResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptedData encrypted_data = 1
     */
    encryptedData: EncryptedData[];
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 2
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.AccountInfo
 */
export interface AccountInfo {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.AccountInfo.Email emails = 1
     */
    emails: AccountInfo_Email[];
    /**
     * The user's login
     *
     * @generated from protobuf field: string login = 2
     */
    login: string;
    /**
     * Any additional login aliases for the user
     *
     * @generated from protobuf field: repeated string login_aliases = 3
     */
    loginAliases: string[];
    /**
     * @generated from protobuf field: google.protobuf.Struct profile = 4
     */
    profile?: Struct;
}
/**
 * @generated from protobuf message c1.connector.v2.AccountInfo.Email
 */
export interface AccountInfo_Email {
    /**
     * @generated from protobuf field: string address = 1
     */
    address: string;
    /**
     * Indicates if this is the user's primary email. Only one entry can be marked as primary.
     *
     * @generated from protobuf field: bool is_primary = 2
     */
    isPrimary: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions
 */
export interface CredentialOptions {
    /**
     * @generated from protobuf oneof: options
     */
    options: {
        oneofKind: "randomPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.CredentialOptions.RandomPassword random_password = 100
         */
        randomPassword: CredentialOptions_RandomPassword;
    } | {
        oneofKind: "noPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.CredentialOptions.NoPassword no_password = 101
         */
        noPassword: CredentialOptions_NoPassword;
    } | {
        oneofKind: "sso";
        /**
         * @generated from protobuf field: c1.connector.v2.CredentialOptions.SSO sso = 102
         */
        sso: CredentialOptions_SSO;
    } | {
        oneofKind: "encryptedPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.CredentialOptions.EncryptedPassword encrypted_password = 103
         */
        encryptedPassword: CredentialOptions_EncryptedPassword;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool force_change_at_next_login = 1
     */
    forceChangeAtNextLogin: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions.RandomPassword
 */
export interface CredentialOptions_RandomPassword {
    /**
     * @generated from protobuf field: int64 length = 1
     */
    length: number;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.PasswordConstraint constraints = 2
     */
    constraints: PasswordConstraint[];
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions.NoPassword
 */
export interface CredentialOptions_NoPassword {
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions.SSO
 */
export interface CredentialOptions_SSO {
    /**
     * @generated from protobuf field: string sso_provider = 1
     */
    ssoProvider: string;
}
/**
 * @generated from protobuf message c1.connector.v2.CredentialOptions.EncryptedPassword
 */
export interface CredentialOptions_EncryptedPassword {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptedData encrypted_passwords = 1
     */
    encryptedPasswords: EncryptedData[];
}
/**
 * Do not use this in any RPC or any message that is in an RPC.
 *
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions
 */
export interface LocalCredentialOptions {
    /**
     * @generated from protobuf oneof: options
     */
    options: {
        oneofKind: "randomPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.LocalCredentialOptions.RandomPassword random_password = 100
         */
        randomPassword: LocalCredentialOptions_RandomPassword;
    } | {
        oneofKind: "noPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.LocalCredentialOptions.NoPassword no_password = 101
         */
        noPassword: LocalCredentialOptions_NoPassword;
    } | {
        oneofKind: "sso";
        /**
         * @generated from protobuf field: c1.connector.v2.LocalCredentialOptions.SSO sso = 102
         */
        sso: LocalCredentialOptions_SSO;
    } | {
        oneofKind: "plaintextPassword";
        /**
         * @generated from protobuf field: c1.connector.v2.LocalCredentialOptions.PlaintextPassword plaintext_password = 103
         */
        plaintextPassword: LocalCredentialOptions_PlaintextPassword;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool force_change_at_next_login = 1
     */
    forceChangeAtNextLogin: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions.RandomPassword
 */
export interface LocalCredentialOptions_RandomPassword {
    /**
     * @generated from protobuf field: int64 length = 1
     */
    length: number;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.PasswordConstraint constraints = 2
     */
    constraints: PasswordConstraint[];
}
/**
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions.NoPassword
 */
export interface LocalCredentialOptions_NoPassword {
}
/**
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions.SSO
 */
export interface LocalCredentialOptions_SSO {
    /**
     * @generated from protobuf field: string sso_provider = 1
     */
    ssoProvider: string;
}
/**
 * @generated from protobuf message c1.connector.v2.LocalCredentialOptions.PlaintextPassword
 */
export interface LocalCredentialOptions_PlaintextPassword {
    /**
     * @generated from protobuf field: string plaintext_password = 1
     */
    plaintextPassword: string;
}
/**
 * @generated from protobuf message c1.connector.v2.PasswordConstraint
 */
export interface PasswordConstraint {
    /**
     * @generated from protobuf field: string char_set = 1
     */
    charSet: string;
    /**
     * @generated from protobuf field: uint32 min_count = 2
     */
    minCount: number;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountRequest
 */
export interface CreateAccountRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.AccountInfo account_info = 1
     */
    accountInfo?: AccountInfo;
    /**
     * @generated from protobuf field: c1.connector.v2.CredentialOptions credential_options = 2
     */
    credentialOptions?: CredentialOptions;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptionConfig encryption_configs = 3
     */
    encryptionConfigs: EncryptionConfig[];
    /**
     * @generated from protobuf field: string resource_type_id = 4
     */
    resourceTypeId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse
 */
export interface CreateAccountResponse {
    /**
     * @generated from protobuf oneof: result
     */
    result: {
        oneofKind: "success";
        /**
         * @generated from protobuf field: c1.connector.v2.CreateAccountResponse.SuccessResult success = 100
         */
        success: CreateAccountResponse_SuccessResult;
    } | {
        oneofKind: "actionRequired";
        /**
         * @generated from protobuf field: c1.connector.v2.CreateAccountResponse.ActionRequiredResult action_required = 101
         */
        actionRequired: CreateAccountResponse_ActionRequiredResult;
    } | {
        oneofKind: "alreadyExists";
        /**
         * @generated from protobuf field: c1.connector.v2.CreateAccountResponse.AlreadyExistsResult already_exists = 102
         */
        alreadyExists: CreateAccountResponse_AlreadyExistsResult;
    } | {
        oneofKind: "inProgress";
        /**
         * @generated from protobuf field: c1.connector.v2.CreateAccountResponse.InProgressResult in_progress = 103
         */
        inProgress: CreateAccountResponse_InProgressResult;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated c1.connector.v2.EncryptedData encrypted_data = 2
     */
    encryptedData: EncryptedData[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse.SuccessResult
 */
export interface CreateAccountResponse_SuccessResult {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1
     */
    resource?: Resource;
    /**
     * @generated from protobuf field: bool is_create_account_result = 2
     */
    isCreateAccountResult: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse.ActionRequiredResult
 */
export interface CreateAccountResponse_ActionRequiredResult {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1
     */
    resource?: Resource;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
    /**
     * @generated from protobuf field: bool is_create_account_result = 3
     */
    isCreateAccountResult: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse.AlreadyExistsResult
 */
export interface CreateAccountResponse_AlreadyExistsResult {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1
     */
    resource?: Resource;
    /**
     * @generated from protobuf field: bool is_create_account_result = 2
     */
    isCreateAccountResult: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.CreateAccountResponse.InProgressResult
 */
export interface CreateAccountResponse_InProgressResult {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1
     */
    resource?: Resource; // Optional.
    /**
     * @generated from protobuf field: bool is_create_account_result = 2
     */
    isCreateAccountResult: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.EncryptedData
 */
export interface EncryptedData {
    /**
     * @generated from protobuf field: string provider = 1
     */
    provider: string;
    /**
     * @deprecated
     * @generated from protobuf field: string key_id = 2 [deprecated = true]
     */
    keyId: string;
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 4
     */
    description: string;
    /**
     * @generated from protobuf field: string schema = 5
     */
    schema: string; // optional
    /**
     * @generated from protobuf field: bytes encrypted_bytes = 6
     */
    encryptedBytes: Uint8Array; // if 'schema' is set, this should be JSON.
    /**
     * @generated from protobuf field: repeated string key_ids = 7
     */
    keyIds: string[];
}
/**
 * @generated from protobuf message c1.connector.v2.PlaintextData
 */
export interface PlaintextData {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: string schema = 3
     */
    schema: string; // optional
    /**
     * @generated from protobuf field: bytes bytes = 4
     */
    bytes: Uint8Array; // if 'schema' is set, this should be JSON.
}
/**
 * @generated from protobuf message c1.connector.v2.EncryptionConfig
 */
export interface EncryptionConfig {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource principal = 1
     */
    principal?: Resource;
    /**
     * @generated from protobuf field: string provider = 2
     */
    provider: string;
    /**
     * @generated from protobuf field: string key_id = 3
     */
    keyId: string;
    /**
     * @generated from protobuf oneof: config
     */
    config: {
        oneofKind: "jwkPublicKeyConfig";
        /**
         * @generated from protobuf field: c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig jwk_public_key_config = 100
         */
        jwkPublicKeyConfig: EncryptionConfig_JWKPublicKeyConfig;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig
 */
export interface EncryptionConfig_JWKPublicKeyConfig {
    /**
     * @generated from protobuf field: bytes pub_key = 1
     */
    pubKey: Uint8Array;
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceId
 */
export interface ResourceId {
    /**
     * @generated from protobuf field: string resource_type = 1
     */
    resourceType: string;
    /**
     * @generated from protobuf field: string resource = 2
     */
    resource: string;
    /**
     * @generated from protobuf field: bool baton_resource = 3
     */
    batonResource: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.Resource
 */
export interface Resource {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId id = 1
     */
    id?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2
     */
    parentResourceId?: ResourceId;
    /**
     * @generated from protobuf field: string display_name = 3
     */
    displayName: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 4
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string description = 5
     */
    description: string;
    /**
     * @generated from protobuf field: bool baton_resource = 6
     */
    batonResource: boolean;
    /**
     * Deprecated. This is no longer used.
     *
     * @deprecated
     * @generated from protobuf field: c1.connector.v2.ExternalId external_id = 7 [deprecated = true]
     */
    externalId?: ExternalId;
    /**
     * Deprecated. This is no longer used.
     *
     * @deprecated
     * @generated from protobuf field: c1.connector.v2.Resource.CreationSource creation_source = 8 [deprecated = true]
     */
    creationSource: Resource_CreationSource;
}
/**
 * @generated from protobuf enum c1.connector.v2.Resource.CreationSource
 */
export enum Resource_CreationSource {
    /**
     * @generated from protobuf enum value: CREATION_SOURCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CREATION_SOURCE_CONNECTOR_LIST_RESOURCES = 1;
     */
    CONNECTOR_LIST_RESOURCES = 1,
    /**
     * @generated from protobuf enum value: CREATION_SOURCE_CONNECTOR_LIST_GRANTS_PRINCIPAL_JIT = 2;
     */
    CONNECTOR_LIST_GRANTS_PRINCIPAL_JIT = 2
}
/**
 * @generated from protobuf message c1.connector.v2.ResourcesServiceListResourcesRequest
 */
export interface ResourcesServiceListResourcesRequest {
    /**
     * @generated from protobuf field: string resource_type_id = 1
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2
     */
    parentResourceId?: ResourceId;
    /**
     * @generated from protobuf field: uint32 page_size = 3
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 5
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string active_sync_id = 6
     */
    activeSyncId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ResourcesServiceListResourcesResponse
 */
export interface ResourcesServiceListResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.Resource list = 1
     */
    list: Resource[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceGetterServiceGetResourceRequest
 */
export interface ResourceGetterServiceGetResourceRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId resource_id = 1
     */
    resourceId?: ResourceId;
    /**
     * @generated from protobuf field: c1.connector.v2.ResourceId parent_resource_id = 2
     */
    parentResourceId?: ResourceId;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string active_sync_id = 4
     */
    activeSyncId: string;
}
/**
 * @generated from protobuf message c1.connector.v2.ResourceGetterServiceGetResourceResponse
 */
export interface ResourceGetterServiceGetResourceResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.Resource resource = 1
     */
    resource?: Resource;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.ExternalId
 */
export interface ExternalId {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string link = 2
     */
    link: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class ResourceType$Type extends MessageType<ResourceType> {
    constructor() {
        super("c1.connector.v2.ResourceType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } },
            { no: 3, name: "traits", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.connector.v2.ResourceType.Trait", ResourceType_Trait, "TRAIT_"], options: { "validate.rules": { repeated: { unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 4, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096", ignoreEmpty: true } } } },
            { no: 6, name: "sourced_externally", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ResourceType>): ResourceType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.traits = [];
        message.annotations = [];
        message.description = "";
        message.sourcedExternally = false;
        if (value !== undefined)
            reflectionMergePartial<ResourceType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceType): ResourceType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* repeated c1.connector.v2.ResourceType.Trait traits */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.traits.push(reader.int32());
                    else
                        message.traits.push(reader.int32());
                    break;
                case /* repeated google.protobuf.Any annotations */ 4:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* bool sourced_externally */ 6:
                    message.sourcedExternally = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* repeated c1.connector.v2.ResourceType.Trait traits = 3; */
        if (message.traits.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.traits.length; i++)
                writer.int32(message.traits[i]);
            writer.join();
        }
        /* repeated google.protobuf.Any annotations = 4; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* bool sourced_externally = 6; */
        if (message.sourcedExternally !== false)
            writer.tag(6, WireType.Varint).bool(message.sourcedExternally);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceType
 */
export const ResourceType = new ResourceType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypesServiceListResourceTypesRequest$Type extends MessageType<ResourceTypesServiceListResourceTypesRequest> {
    constructor() {
        super("c1.connector.v2.ResourceTypesServiceListResourceTypesRequest", [
            { no: 1, name: "parent", kind: "message", T: () => Resource },
            { no: 2, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 250, ignoreEmpty: true } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576", ignoreEmpty: true } } } },
            { no: 4, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 5, name: "active_sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ResourceTypesServiceListResourceTypesRequest>): ResourceTypesServiceListResourceTypesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.annotations = [];
        message.activeSyncId = "";
        if (value !== undefined)
            reflectionMergePartial<ResourceTypesServiceListResourceTypesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceTypesServiceListResourceTypesRequest): ResourceTypesServiceListResourceTypesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource parent */ 1:
                    message.parent = Resource.internalBinaryRead(reader, reader.uint32(), options, message.parent);
                    break;
                case /* uint32 page_size */ 2:
                    message.pageSize = reader.uint32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 4:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string active_sync_id */ 5:
                    message.activeSyncId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceTypesServiceListResourceTypesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource parent = 1; */
        if (message.parent)
            Resource.internalBinaryWrite(message.parent, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* uint32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).uint32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated google.protobuf.Any annotations = 4; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string active_sync_id = 5; */
        if (message.activeSyncId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.activeSyncId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceTypesServiceListResourceTypesRequest
 */
export const ResourceTypesServiceListResourceTypesRequest = new ResourceTypesServiceListResourceTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceTypesServiceListResourceTypesResponse$Type extends MessageType<ResourceTypesServiceListResourceTypesResponse> {
    constructor() {
        super("c1.connector.v2.ResourceTypesServiceListResourceTypesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576", ignoreEmpty: true } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ResourceTypesServiceListResourceTypesResponse>): ResourceTypesServiceListResourceTypesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<ResourceTypesServiceListResourceTypesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceTypesServiceListResourceTypesResponse): ResourceTypesServiceListResourceTypesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.ResourceType list */ 1:
                    message.list.push(ResourceType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 3:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceTypesServiceListResourceTypesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.ResourceType list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ResourceType.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any annotations = 3; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceTypesServiceListResourceTypesResponse
 */
export const ResourceTypesServiceListResourceTypesResponse = new ResourceTypesServiceListResourceTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateResourceRequest$Type extends MessageType<CreateResourceRequest> {
    constructor() {
        super("c1.connector.v2.CreateResourceRequest", [
            { no: 1, name: "resource", kind: "message", T: () => Resource }
        ]);
    }
    create(value?: PartialMessage<CreateResourceRequest>): CreateResourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CreateResourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateResourceRequest): CreateResourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource resource */ 1:
                    message.resource = Resource.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateResourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource resource = 1; */
        if (message.resource)
            Resource.internalBinaryWrite(message.resource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateResourceRequest
 */
export const CreateResourceRequest = new CreateResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateResourceResponse$Type extends MessageType<CreateResourceResponse> {
    constructor() {
        super("c1.connector.v2.CreateResourceResponse", [
            { no: 1, name: "created", kind: "message", T: () => Resource },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<CreateResourceResponse>): CreateResourceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<CreateResourceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateResourceResponse): CreateResourceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource created */ 1:
                    message.created = Resource.internalBinaryRead(reader, reader.uint32(), options, message.created);
                    break;
                case /* repeated google.protobuf.Any annotations */ 2:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateResourceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource created = 1; */
        if (message.created)
            Resource.internalBinaryWrite(message.created, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 2; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateResourceResponse
 */
export const CreateResourceResponse = new CreateResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResourceRequest$Type extends MessageType<DeleteResourceRequest> {
    constructor() {
        super("c1.connector.v2.DeleteResourceRequest", [
            { no: 1, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId }
        ]);
    }
    create(value?: PartialMessage<DeleteResourceRequest>): DeleteResourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteResourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteResourceRequest): DeleteResourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.ResourceId resource_id */ 1:
                    message.resourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.resourceId);
                    break;
                case /* c1.connector.v2.ResourceId parent_resource_id */ 2:
                    message.parentResourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.parentResourceId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteResourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.ResourceId resource_id = 1; */
        if (message.resourceId)
            ResourceId.internalBinaryWrite(message.resourceId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ResourceId parent_resource_id = 2; */
        if (message.parentResourceId)
            ResourceId.internalBinaryWrite(message.parentResourceId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.DeleteResourceRequest
 */
export const DeleteResourceRequest = new DeleteResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResourceResponse$Type extends MessageType<DeleteResourceResponse> {
    constructor() {
        super("c1.connector.v2.DeleteResourceResponse", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DeleteResourceResponse>): DeleteResourceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<DeleteResourceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteResourceResponse): DeleteResourceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated google.protobuf.Any annotations */ 1:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteResourceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated google.protobuf.Any annotations = 1; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.DeleteResourceResponse
 */
export const DeleteResourceResponse = new DeleteResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResourceV2Request$Type extends MessageType<DeleteResourceV2Request> {
    constructor() {
        super("c1.connector.v2.DeleteResourceV2Request", [
            { no: 1, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId }
        ]);
    }
    create(value?: PartialMessage<DeleteResourceV2Request>): DeleteResourceV2Request {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<DeleteResourceV2Request>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteResourceV2Request): DeleteResourceV2Request {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.ResourceId resource_id */ 1:
                    message.resourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.resourceId);
                    break;
                case /* c1.connector.v2.ResourceId parent_resource_id */ 2:
                    message.parentResourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.parentResourceId);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteResourceV2Request, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.ResourceId resource_id = 1; */
        if (message.resourceId)
            ResourceId.internalBinaryWrite(message.resourceId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ResourceId parent_resource_id = 2; */
        if (message.parentResourceId)
            ResourceId.internalBinaryWrite(message.parentResourceId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.DeleteResourceV2Request
 */
export const DeleteResourceV2Request = new DeleteResourceV2Request$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteResourceV2Response$Type extends MessageType<DeleteResourceV2Response> {
    constructor() {
        super("c1.connector.v2.DeleteResourceV2Response", [
            { no: 1, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<DeleteResourceV2Response>): DeleteResourceV2Response {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<DeleteResourceV2Response>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeleteResourceV2Response): DeleteResourceV2Response {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated google.protobuf.Any annotations */ 1:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeleteResourceV2Response, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated google.protobuf.Any annotations = 1; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.DeleteResourceV2Response
 */
export const DeleteResourceV2Response = new DeleteResourceV2Response$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateCredentialRequest$Type extends MessageType<RotateCredentialRequest> {
    constructor() {
        super("c1.connector.v2.RotateCredentialRequest", [
            { no: 1, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 2, name: "credential_options", kind: "message", T: () => CredentialOptions },
            { no: 3, name: "encryption_configs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptionConfig }
        ]);
    }
    create(value?: PartialMessage<RotateCredentialRequest>): RotateCredentialRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.encryptionConfigs = [];
        if (value !== undefined)
            reflectionMergePartial<RotateCredentialRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RotateCredentialRequest): RotateCredentialRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.ResourceId resource_id */ 1:
                    message.resourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.resourceId);
                    break;
                case /* c1.connector.v2.CredentialOptions credential_options */ 2:
                    message.credentialOptions = CredentialOptions.internalBinaryRead(reader, reader.uint32(), options, message.credentialOptions);
                    break;
                case /* repeated c1.connector.v2.EncryptionConfig encryption_configs */ 3:
                    message.encryptionConfigs.push(EncryptionConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RotateCredentialRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.ResourceId resource_id = 1; */
        if (message.resourceId)
            ResourceId.internalBinaryWrite(message.resourceId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CredentialOptions credential_options = 2; */
        if (message.credentialOptions)
            CredentialOptions.internalBinaryWrite(message.credentialOptions, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.EncryptionConfig encryption_configs = 3; */
        for (let i = 0; i < message.encryptionConfigs.length; i++)
            EncryptionConfig.internalBinaryWrite(message.encryptionConfigs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.RotateCredentialRequest
 */
export const RotateCredentialRequest = new RotateCredentialRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotateCredentialResponse$Type extends MessageType<RotateCredentialResponse> {
    constructor() {
        super("c1.connector.v2.RotateCredentialResponse", [
            { no: 1, name: "encrypted_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptedData },
            { no: 2, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<RotateCredentialResponse>): RotateCredentialResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.encryptedData = [];
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<RotateCredentialResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RotateCredentialResponse): RotateCredentialResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.EncryptedData encrypted_data */ 1:
                    message.encryptedData.push(EncryptedData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.connector.v2.ResourceId resource_id */ 2:
                    message.resourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.resourceId);
                    break;
                case /* repeated google.protobuf.Any annotations */ 3:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RotateCredentialResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.EncryptedData encrypted_data = 1; */
        for (let i = 0; i < message.encryptedData.length; i++)
            EncryptedData.internalBinaryWrite(message.encryptedData[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ResourceId resource_id = 2; */
        if (message.resourceId)
            ResourceId.internalBinaryWrite(message.resourceId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 3; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.RotateCredentialResponse
 */
export const RotateCredentialResponse = new RotateCredentialResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountInfo$Type extends MessageType<AccountInfo> {
    constructor() {
        super("c1.connector.v2.AccountInfo", [
            { no: 1, name: "emails", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccountInfo_Email },
            { no: 2, name: "login", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "login_aliases", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "profile", kind: "message", T: () => Struct }
        ]);
    }
    create(value?: PartialMessage<AccountInfo>): AccountInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.emails = [];
        message.login = "";
        message.loginAliases = [];
        if (value !== undefined)
            reflectionMergePartial<AccountInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountInfo): AccountInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.AccountInfo.Email emails */ 1:
                    message.emails.push(AccountInfo_Email.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string login */ 2:
                    message.login = reader.string();
                    break;
                case /* repeated string login_aliases */ 3:
                    message.loginAliases.push(reader.string());
                    break;
                case /* google.protobuf.Struct profile */ 4:
                    message.profile = Struct.internalBinaryRead(reader, reader.uint32(), options, message.profile);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.AccountInfo.Email emails = 1; */
        for (let i = 0; i < message.emails.length; i++)
            AccountInfo_Email.internalBinaryWrite(message.emails[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string login = 2; */
        if (message.login !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.login);
        /* repeated string login_aliases = 3; */
        for (let i = 0; i < message.loginAliases.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.loginAliases[i]);
        /* google.protobuf.Struct profile = 4; */
        if (message.profile)
            Struct.internalBinaryWrite(message.profile, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AccountInfo
 */
export const AccountInfo = new AccountInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountInfo_Email$Type extends MessageType<AccountInfo_Email> {
    constructor() {
        super("c1.connector.v2.AccountInfo.Email", [
            { no: 1, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { email: true } } } },
            { no: 2, name: "is_primary", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AccountInfo_Email>): AccountInfo_Email {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.address = "";
        message.isPrimary = false;
        if (value !== undefined)
            reflectionMergePartial<AccountInfo_Email>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AccountInfo_Email): AccountInfo_Email {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string address */ 1:
                    message.address = reader.string();
                    break;
                case /* bool is_primary */ 2:
                    message.isPrimary = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AccountInfo_Email, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string address = 1; */
        if (message.address !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.address);
        /* bool is_primary = 2; */
        if (message.isPrimary !== false)
            writer.tag(2, WireType.Varint).bool(message.isPrimary);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.AccountInfo.Email
 */
export const AccountInfo_Email = new AccountInfo_Email$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions$Type extends MessageType<CredentialOptions> {
    constructor() {
        super("c1.connector.v2.CredentialOptions", [
            { no: 100, name: "random_password", kind: "message", oneof: "options", T: () => CredentialOptions_RandomPassword },
            { no: 101, name: "no_password", kind: "message", oneof: "options", T: () => CredentialOptions_NoPassword },
            { no: 102, name: "sso", kind: "message", oneof: "options", T: () => CredentialOptions_SSO },
            { no: 103, name: "encrypted_password", kind: "message", oneof: "options", T: () => CredentialOptions_EncryptedPassword },
            { no: 1, name: "force_change_at_next_login", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CredentialOptions>): CredentialOptions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.options = { oneofKind: undefined };
        message.forceChangeAtNextLogin = false;
        if (value !== undefined)
            reflectionMergePartial<CredentialOptions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialOptions): CredentialOptions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.CredentialOptions.RandomPassword random_password */ 100:
                    message.options = {
                        oneofKind: "randomPassword",
                        randomPassword: CredentialOptions_RandomPassword.internalBinaryRead(reader, reader.uint32(), options, (message.options as any).randomPassword)
                    };
                    break;
                case /* c1.connector.v2.CredentialOptions.NoPassword no_password */ 101:
                    message.options = {
                        oneofKind: "noPassword",
                        noPassword: CredentialOptions_NoPassword.internalBinaryRead(reader, reader.uint32(), options, (message.options as any).noPassword)
                    };
                    break;
                case /* c1.connector.v2.CredentialOptions.SSO sso */ 102:
                    message.options = {
                        oneofKind: "sso",
                        sso: CredentialOptions_SSO.internalBinaryRead(reader, reader.uint32(), options, (message.options as any).sso)
                    };
                    break;
                case /* c1.connector.v2.CredentialOptions.EncryptedPassword encrypted_password */ 103:
                    message.options = {
                        oneofKind: "encryptedPassword",
                        encryptedPassword: CredentialOptions_EncryptedPassword.internalBinaryRead(reader, reader.uint32(), options, (message.options as any).encryptedPassword)
                    };
                    break;
                case /* bool force_change_at_next_login */ 1:
                    message.forceChangeAtNextLogin = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialOptions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool force_change_at_next_login = 1; */
        if (message.forceChangeAtNextLogin !== false)
            writer.tag(1, WireType.Varint).bool(message.forceChangeAtNextLogin);
        /* c1.connector.v2.CredentialOptions.RandomPassword random_password = 100; */
        if (message.options.oneofKind === "randomPassword")
            CredentialOptions_RandomPassword.internalBinaryWrite(message.options.randomPassword, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CredentialOptions.NoPassword no_password = 101; */
        if (message.options.oneofKind === "noPassword")
            CredentialOptions_NoPassword.internalBinaryWrite(message.options.noPassword, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CredentialOptions.SSO sso = 102; */
        if (message.options.oneofKind === "sso")
            CredentialOptions_SSO.internalBinaryWrite(message.options.sso, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CredentialOptions.EncryptedPassword encrypted_password = 103; */
        if (message.options.oneofKind === "encryptedPassword")
            CredentialOptions_EncryptedPassword.internalBinaryWrite(message.options.encryptedPassword, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions
 */
export const CredentialOptions = new CredentialOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions_RandomPassword$Type extends MessageType<CredentialOptions_RandomPassword> {
    constructor() {
        super("c1.connector.v2.CredentialOptions.RandomPassword", [
            { no: 1, name: "length", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { lte: "64", gte: "8" } } } },
            { no: 2, name: "constraints", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordConstraint }
        ]);
    }
    create(value?: PartialMessage<CredentialOptions_RandomPassword>): CredentialOptions_RandomPassword {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.length = 0;
        message.constraints = [];
        if (value !== undefined)
            reflectionMergePartial<CredentialOptions_RandomPassword>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialOptions_RandomPassword): CredentialOptions_RandomPassword {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 length */ 1:
                    message.length = reader.int64().toNumber();
                    break;
                case /* repeated c1.connector.v2.PasswordConstraint constraints */ 2:
                    message.constraints.push(PasswordConstraint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialOptions_RandomPassword, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 length = 1; */
        if (message.length !== 0)
            writer.tag(1, WireType.Varint).int64(message.length);
        /* repeated c1.connector.v2.PasswordConstraint constraints = 2; */
        for (let i = 0; i < message.constraints.length; i++)
            PasswordConstraint.internalBinaryWrite(message.constraints[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions.RandomPassword
 */
export const CredentialOptions_RandomPassword = new CredentialOptions_RandomPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions_NoPassword$Type extends MessageType<CredentialOptions_NoPassword> {
    constructor() {
        super("c1.connector.v2.CredentialOptions.NoPassword", []);
    }
    create(value?: PartialMessage<CredentialOptions_NoPassword>): CredentialOptions_NoPassword {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<CredentialOptions_NoPassword>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialOptions_NoPassword): CredentialOptions_NoPassword {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialOptions_NoPassword, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions.NoPassword
 */
export const CredentialOptions_NoPassword = new CredentialOptions_NoPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions_SSO$Type extends MessageType<CredentialOptions_SSO> {
    constructor() {
        super("c1.connector.v2.CredentialOptions.SSO", [
            { no: 1, name: "sso_provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CredentialOptions_SSO>): CredentialOptions_SSO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ssoProvider = "";
        if (value !== undefined)
            reflectionMergePartial<CredentialOptions_SSO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialOptions_SSO): CredentialOptions_SSO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sso_provider */ 1:
                    message.ssoProvider = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialOptions_SSO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sso_provider = 1; */
        if (message.ssoProvider !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ssoProvider);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions.SSO
 */
export const CredentialOptions_SSO = new CredentialOptions_SSO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CredentialOptions_EncryptedPassword$Type extends MessageType<CredentialOptions_EncryptedPassword> {
    constructor() {
        super("c1.connector.v2.CredentialOptions.EncryptedPassword", [
            { no: 1, name: "encrypted_passwords", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptedData, options: { "validate.rules": { repeated: { minItems: "1" } } } }
        ]);
    }
    create(value?: PartialMessage<CredentialOptions_EncryptedPassword>): CredentialOptions_EncryptedPassword {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.encryptedPasswords = [];
        if (value !== undefined)
            reflectionMergePartial<CredentialOptions_EncryptedPassword>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CredentialOptions_EncryptedPassword): CredentialOptions_EncryptedPassword {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.EncryptedData encrypted_passwords */ 1:
                    message.encryptedPasswords.push(EncryptedData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CredentialOptions_EncryptedPassword, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.EncryptedData encrypted_passwords = 1; */
        for (let i = 0; i < message.encryptedPasswords.length; i++)
            EncryptedData.internalBinaryWrite(message.encryptedPasswords[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CredentialOptions.EncryptedPassword
 */
export const CredentialOptions_EncryptedPassword = new CredentialOptions_EncryptedPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions$Type extends MessageType<LocalCredentialOptions> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions", [
            { no: 100, name: "random_password", kind: "message", oneof: "options", T: () => LocalCredentialOptions_RandomPassword },
            { no: 101, name: "no_password", kind: "message", oneof: "options", T: () => LocalCredentialOptions_NoPassword },
            { no: 102, name: "sso", kind: "message", oneof: "options", T: () => LocalCredentialOptions_SSO },
            { no: 103, name: "plaintext_password", kind: "message", oneof: "options", T: () => LocalCredentialOptions_PlaintextPassword },
            { no: 1, name: "force_change_at_next_login", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<LocalCredentialOptions>): LocalCredentialOptions {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.options = { oneofKind: undefined };
        message.forceChangeAtNextLogin = false;
        if (value !== undefined)
            reflectionMergePartial<LocalCredentialOptions>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LocalCredentialOptions): LocalCredentialOptions {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.LocalCredentialOptions.RandomPassword random_password */ 100:
                    message.options = {
                        oneofKind: "randomPassword",
                        randomPassword: LocalCredentialOptions_RandomPassword.internalBinaryRead(reader, reader.uint32(), options, (message.options as any).randomPassword)
                    };
                    break;
                case /* c1.connector.v2.LocalCredentialOptions.NoPassword no_password */ 101:
                    message.options = {
                        oneofKind: "noPassword",
                        noPassword: LocalCredentialOptions_NoPassword.internalBinaryRead(reader, reader.uint32(), options, (message.options as any).noPassword)
                    };
                    break;
                case /* c1.connector.v2.LocalCredentialOptions.SSO sso */ 102:
                    message.options = {
                        oneofKind: "sso",
                        sso: LocalCredentialOptions_SSO.internalBinaryRead(reader, reader.uint32(), options, (message.options as any).sso)
                    };
                    break;
                case /* c1.connector.v2.LocalCredentialOptions.PlaintextPassword plaintext_password */ 103:
                    message.options = {
                        oneofKind: "plaintextPassword",
                        plaintextPassword: LocalCredentialOptions_PlaintextPassword.internalBinaryRead(reader, reader.uint32(), options, (message.options as any).plaintextPassword)
                    };
                    break;
                case /* bool force_change_at_next_login */ 1:
                    message.forceChangeAtNextLogin = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LocalCredentialOptions, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool force_change_at_next_login = 1; */
        if (message.forceChangeAtNextLogin !== false)
            writer.tag(1, WireType.Varint).bool(message.forceChangeAtNextLogin);
        /* c1.connector.v2.LocalCredentialOptions.RandomPassword random_password = 100; */
        if (message.options.oneofKind === "randomPassword")
            LocalCredentialOptions_RandomPassword.internalBinaryWrite(message.options.randomPassword, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.LocalCredentialOptions.NoPassword no_password = 101; */
        if (message.options.oneofKind === "noPassword")
            LocalCredentialOptions_NoPassword.internalBinaryWrite(message.options.noPassword, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.LocalCredentialOptions.SSO sso = 102; */
        if (message.options.oneofKind === "sso")
            LocalCredentialOptions_SSO.internalBinaryWrite(message.options.sso, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.LocalCredentialOptions.PlaintextPassword plaintext_password = 103; */
        if (message.options.oneofKind === "plaintextPassword")
            LocalCredentialOptions_PlaintextPassword.internalBinaryWrite(message.options.plaintextPassword, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions
 */
export const LocalCredentialOptions = new LocalCredentialOptions$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions_RandomPassword$Type extends MessageType<LocalCredentialOptions_RandomPassword> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions.RandomPassword", [
            { no: 1, name: "length", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "validate.rules": { int64: { lte: "64", gte: "8" } } } },
            { no: 2, name: "constraints", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordConstraint }
        ]);
    }
    create(value?: PartialMessage<LocalCredentialOptions_RandomPassword>): LocalCredentialOptions_RandomPassword {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.length = 0;
        message.constraints = [];
        if (value !== undefined)
            reflectionMergePartial<LocalCredentialOptions_RandomPassword>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LocalCredentialOptions_RandomPassword): LocalCredentialOptions_RandomPassword {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 length */ 1:
                    message.length = reader.int64().toNumber();
                    break;
                case /* repeated c1.connector.v2.PasswordConstraint constraints */ 2:
                    message.constraints.push(PasswordConstraint.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LocalCredentialOptions_RandomPassword, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 length = 1; */
        if (message.length !== 0)
            writer.tag(1, WireType.Varint).int64(message.length);
        /* repeated c1.connector.v2.PasswordConstraint constraints = 2; */
        for (let i = 0; i < message.constraints.length; i++)
            PasswordConstraint.internalBinaryWrite(message.constraints[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions.RandomPassword
 */
export const LocalCredentialOptions_RandomPassword = new LocalCredentialOptions_RandomPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions_NoPassword$Type extends MessageType<LocalCredentialOptions_NoPassword> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions.NoPassword", []);
    }
    create(value?: PartialMessage<LocalCredentialOptions_NoPassword>): LocalCredentialOptions_NoPassword {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<LocalCredentialOptions_NoPassword>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LocalCredentialOptions_NoPassword): LocalCredentialOptions_NoPassword {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LocalCredentialOptions_NoPassword, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions.NoPassword
 */
export const LocalCredentialOptions_NoPassword = new LocalCredentialOptions_NoPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions_SSO$Type extends MessageType<LocalCredentialOptions_SSO> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions.SSO", [
            { no: 1, name: "sso_provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LocalCredentialOptions_SSO>): LocalCredentialOptions_SSO {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ssoProvider = "";
        if (value !== undefined)
            reflectionMergePartial<LocalCredentialOptions_SSO>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LocalCredentialOptions_SSO): LocalCredentialOptions_SSO {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string sso_provider */ 1:
                    message.ssoProvider = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LocalCredentialOptions_SSO, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string sso_provider = 1; */
        if (message.ssoProvider !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.ssoProvider);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions.SSO
 */
export const LocalCredentialOptions_SSO = new LocalCredentialOptions_SSO$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LocalCredentialOptions_PlaintextPassword$Type extends MessageType<LocalCredentialOptions_PlaintextPassword> {
    constructor() {
        super("c1.connector.v2.LocalCredentialOptions.PlaintextPassword", [
            { no: 1, name: "plaintext_password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LocalCredentialOptions_PlaintextPassword>): LocalCredentialOptions_PlaintextPassword {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.plaintextPassword = "";
        if (value !== undefined)
            reflectionMergePartial<LocalCredentialOptions_PlaintextPassword>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LocalCredentialOptions_PlaintextPassword): LocalCredentialOptions_PlaintextPassword {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string plaintext_password */ 1:
                    message.plaintextPassword = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LocalCredentialOptions_PlaintextPassword, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string plaintext_password = 1; */
        if (message.plaintextPassword !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.plaintextPassword);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.LocalCredentialOptions.PlaintextPassword
 */
export const LocalCredentialOptions_PlaintextPassword = new LocalCredentialOptions_PlaintextPassword$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordConstraint$Type extends MessageType<PasswordConstraint> {
    constructor() {
        super("c1.connector.v2.PasswordConstraint", [
            { no: 1, name: "char_set", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "min_count", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordConstraint>): PasswordConstraint {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.charSet = "";
        message.minCount = 0;
        if (value !== undefined)
            reflectionMergePartial<PasswordConstraint>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordConstraint): PasswordConstraint {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string char_set */ 1:
                    message.charSet = reader.string();
                    break;
                case /* uint32 min_count */ 2:
                    message.minCount = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordConstraint, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string char_set = 1; */
        if (message.charSet !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.charSet);
        /* uint32 min_count = 2; */
        if (message.minCount !== 0)
            writer.tag(2, WireType.Varint).uint32(message.minCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.PasswordConstraint
 */
export const PasswordConstraint = new PasswordConstraint$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountRequest$Type extends MessageType<CreateAccountRequest> {
    constructor() {
        super("c1.connector.v2.CreateAccountRequest", [
            { no: 1, name: "account_info", kind: "message", T: () => AccountInfo },
            { no: 2, name: "credential_options", kind: "message", T: () => CredentialOptions },
            { no: 3, name: "encryption_configs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptionConfig },
            { no: 4, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<CreateAccountRequest>): CreateAccountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.encryptionConfigs = [];
        message.resourceTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<CreateAccountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountRequest): CreateAccountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.AccountInfo account_info */ 1:
                    message.accountInfo = AccountInfo.internalBinaryRead(reader, reader.uint32(), options, message.accountInfo);
                    break;
                case /* c1.connector.v2.CredentialOptions credential_options */ 2:
                    message.credentialOptions = CredentialOptions.internalBinaryRead(reader, reader.uint32(), options, message.credentialOptions);
                    break;
                case /* repeated c1.connector.v2.EncryptionConfig encryption_configs */ 3:
                    message.encryptionConfigs.push(EncryptionConfig.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string resource_type_id */ 4:
                    message.resourceTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.AccountInfo account_info = 1; */
        if (message.accountInfo)
            AccountInfo.internalBinaryWrite(message.accountInfo, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CredentialOptions credential_options = 2; */
        if (message.credentialOptions)
            CredentialOptions.internalBinaryWrite(message.credentialOptions, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.EncryptionConfig encryption_configs = 3; */
        for (let i = 0; i < message.encryptionConfigs.length; i++)
            EncryptionConfig.internalBinaryWrite(message.encryptionConfigs[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string resource_type_id = 4; */
        if (message.resourceTypeId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountRequest
 */
export const CreateAccountRequest = new CreateAccountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse$Type extends MessageType<CreateAccountResponse> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse", [
            { no: 100, name: "success", kind: "message", oneof: "result", T: () => CreateAccountResponse_SuccessResult },
            { no: 101, name: "action_required", kind: "message", oneof: "result", T: () => CreateAccountResponse_ActionRequiredResult },
            { no: 102, name: "already_exists", kind: "message", oneof: "result", T: () => CreateAccountResponse_AlreadyExistsResult },
            { no: 103, name: "in_progress", kind: "message", oneof: "result", T: () => CreateAccountResponse_InProgressResult },
            { no: 2, name: "encrypted_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EncryptedData },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<CreateAccountResponse>): CreateAccountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.result = { oneofKind: undefined };
        message.encryptedData = [];
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<CreateAccountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountResponse): CreateAccountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.CreateAccountResponse.SuccessResult success */ 100:
                    message.result = {
                        oneofKind: "success",
                        success: CreateAccountResponse_SuccessResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).success)
                    };
                    break;
                case /* c1.connector.v2.CreateAccountResponse.ActionRequiredResult action_required */ 101:
                    message.result = {
                        oneofKind: "actionRequired",
                        actionRequired: CreateAccountResponse_ActionRequiredResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).actionRequired)
                    };
                    break;
                case /* c1.connector.v2.CreateAccountResponse.AlreadyExistsResult already_exists */ 102:
                    message.result = {
                        oneofKind: "alreadyExists",
                        alreadyExists: CreateAccountResponse_AlreadyExistsResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).alreadyExists)
                    };
                    break;
                case /* c1.connector.v2.CreateAccountResponse.InProgressResult in_progress */ 103:
                    message.result = {
                        oneofKind: "inProgress",
                        inProgress: CreateAccountResponse_InProgressResult.internalBinaryRead(reader, reader.uint32(), options, (message.result as any).inProgress)
                    };
                    break;
                case /* repeated c1.connector.v2.EncryptedData encrypted_data */ 2:
                    message.encryptedData.push(EncryptedData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any annotations */ 3:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.EncryptedData encrypted_data = 2; */
        for (let i = 0; i < message.encryptedData.length; i++)
            EncryptedData.internalBinaryWrite(message.encryptedData[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 3; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CreateAccountResponse.SuccessResult success = 100; */
        if (message.result.oneofKind === "success")
            CreateAccountResponse_SuccessResult.internalBinaryWrite(message.result.success, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CreateAccountResponse.ActionRequiredResult action_required = 101; */
        if (message.result.oneofKind === "actionRequired")
            CreateAccountResponse_ActionRequiredResult.internalBinaryWrite(message.result.actionRequired, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CreateAccountResponse.AlreadyExistsResult already_exists = 102; */
        if (message.result.oneofKind === "alreadyExists")
            CreateAccountResponse_AlreadyExistsResult.internalBinaryWrite(message.result.alreadyExists, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.CreateAccountResponse.InProgressResult in_progress = 103; */
        if (message.result.oneofKind === "inProgress")
            CreateAccountResponse_InProgressResult.internalBinaryWrite(message.result.inProgress, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse
 */
export const CreateAccountResponse = new CreateAccountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse_SuccessResult$Type extends MessageType<CreateAccountResponse_SuccessResult> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse.SuccessResult", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "is_create_account_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccountResponse_SuccessResult>): CreateAccountResponse_SuccessResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isCreateAccountResult = false;
        if (value !== undefined)
            reflectionMergePartial<CreateAccountResponse_SuccessResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountResponse_SuccessResult): CreateAccountResponse_SuccessResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource resource */ 1:
                    message.resource = Resource.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                case /* bool is_create_account_result */ 2:
                    message.isCreateAccountResult = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountResponse_SuccessResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource resource = 1; */
        if (message.resource)
            Resource.internalBinaryWrite(message.resource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_create_account_result = 2; */
        if (message.isCreateAccountResult !== false)
            writer.tag(2, WireType.Varint).bool(message.isCreateAccountResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse.SuccessResult
 */
export const CreateAccountResponse_SuccessResult = new CreateAccountResponse_SuccessResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse_ActionRequiredResult$Type extends MessageType<CreateAccountResponse_ActionRequiredResult> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse.ActionRequiredResult", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "is_create_account_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccountResponse_ActionRequiredResult>): CreateAccountResponse_ActionRequiredResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = "";
        message.isCreateAccountResult = false;
        if (value !== undefined)
            reflectionMergePartial<CreateAccountResponse_ActionRequiredResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountResponse_ActionRequiredResult): CreateAccountResponse_ActionRequiredResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource resource */ 1:
                    message.resource = Resource.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                case /* bool is_create_account_result */ 3:
                    message.isCreateAccountResult = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountResponse_ActionRequiredResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource resource = 1; */
        if (message.resource)
            Resource.internalBinaryWrite(message.resource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        /* bool is_create_account_result = 3; */
        if (message.isCreateAccountResult !== false)
            writer.tag(3, WireType.Varint).bool(message.isCreateAccountResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse.ActionRequiredResult
 */
export const CreateAccountResponse_ActionRequiredResult = new CreateAccountResponse_ActionRequiredResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse_AlreadyExistsResult$Type extends MessageType<CreateAccountResponse_AlreadyExistsResult> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse.AlreadyExistsResult", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "is_create_account_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccountResponse_AlreadyExistsResult>): CreateAccountResponse_AlreadyExistsResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isCreateAccountResult = false;
        if (value !== undefined)
            reflectionMergePartial<CreateAccountResponse_AlreadyExistsResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountResponse_AlreadyExistsResult): CreateAccountResponse_AlreadyExistsResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource resource */ 1:
                    message.resource = Resource.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                case /* bool is_create_account_result */ 2:
                    message.isCreateAccountResult = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountResponse_AlreadyExistsResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource resource = 1; */
        if (message.resource)
            Resource.internalBinaryWrite(message.resource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_create_account_result = 2; */
        if (message.isCreateAccountResult !== false)
            writer.tag(2, WireType.Varint).bool(message.isCreateAccountResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse.AlreadyExistsResult
 */
export const CreateAccountResponse_AlreadyExistsResult = new CreateAccountResponse_AlreadyExistsResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAccountResponse_InProgressResult$Type extends MessageType<CreateAccountResponse_InProgressResult> {
    constructor() {
        super("c1.connector.v2.CreateAccountResponse.InProgressResult", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "is_create_account_result", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CreateAccountResponse_InProgressResult>): CreateAccountResponse_InProgressResult {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isCreateAccountResult = false;
        if (value !== undefined)
            reflectionMergePartial<CreateAccountResponse_InProgressResult>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CreateAccountResponse_InProgressResult): CreateAccountResponse_InProgressResult {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource resource */ 1:
                    message.resource = Resource.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                case /* bool is_create_account_result */ 2:
                    message.isCreateAccountResult = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CreateAccountResponse_InProgressResult, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource resource = 1; */
        if (message.resource)
            Resource.internalBinaryWrite(message.resource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* bool is_create_account_result = 2; */
        if (message.isCreateAccountResult !== false)
            writer.tag(2, WireType.Varint).bool(message.isCreateAccountResult);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.CreateAccountResponse.InProgressResult
 */
export const CreateAccountResponse_InProgressResult = new CreateAccountResponse_InProgressResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptedData$Type extends MessageType<EncryptedData> {
    constructor() {
        super("c1.connector.v2.EncryptedData", [
            { no: 1, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "key_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "schema", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "encrypted_bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 7, name: "key_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<EncryptedData>): EncryptedData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.provider = "";
        message.keyId = "";
        message.name = "";
        message.description = "";
        message.schema = "";
        message.encryptedBytes = new Uint8Array(0);
        message.keyIds = [];
        if (value !== undefined)
            reflectionMergePartial<EncryptedData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EncryptedData): EncryptedData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string provider */ 1:
                    message.provider = reader.string();
                    break;
                case /* string key_id = 2 [deprecated = true] */ 2:
                    message.keyId = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* string description */ 4:
                    message.description = reader.string();
                    break;
                case /* string schema */ 5:
                    message.schema = reader.string();
                    break;
                case /* bytes encrypted_bytes */ 6:
                    message.encryptedBytes = reader.bytes();
                    break;
                case /* repeated string key_ids */ 7:
                    message.keyIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EncryptedData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string provider = 1; */
        if (message.provider !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.provider);
        /* string key_id = 2 [deprecated = true]; */
        if (message.keyId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.keyId);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* string description = 4; */
        if (message.description !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.description);
        /* string schema = 5; */
        if (message.schema !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.schema);
        /* bytes encrypted_bytes = 6; */
        if (message.encryptedBytes.length)
            writer.tag(6, WireType.LengthDelimited).bytes(message.encryptedBytes);
        /* repeated string key_ids = 7; */
        for (let i = 0; i < message.keyIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.keyIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.EncryptedData
 */
export const EncryptedData = new EncryptedData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PlaintextData$Type extends MessageType<PlaintextData> {
    constructor() {
        super("c1.connector.v2.PlaintextData", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "schema", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "bytes", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<PlaintextData>): PlaintextData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.description = "";
        message.schema = "";
        message.bytes = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<PlaintextData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PlaintextData): PlaintextData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* string schema */ 3:
                    message.schema = reader.string();
                    break;
                case /* bytes bytes */ 4:
                    message.bytes = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PlaintextData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* string schema = 3; */
        if (message.schema !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.schema);
        /* bytes bytes = 4; */
        if (message.bytes.length)
            writer.tag(4, WireType.LengthDelimited).bytes(message.bytes);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.PlaintextData
 */
export const PlaintextData = new PlaintextData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptionConfig$Type extends MessageType<EncryptionConfig> {
    constructor() {
        super("c1.connector.v2.EncryptionConfig", [
            { no: 1, name: "principal", kind: "message", T: () => Resource },
            { no: 2, name: "provider", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "key_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "jwk_public_key_config", kind: "message", oneof: "config", T: () => EncryptionConfig_JWKPublicKeyConfig }
        ]);
    }
    create(value?: PartialMessage<EncryptionConfig>): EncryptionConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.provider = "";
        message.keyId = "";
        message.config = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<EncryptionConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EncryptionConfig): EncryptionConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource principal */ 1:
                    message.principal = Resource.internalBinaryRead(reader, reader.uint32(), options, message.principal);
                    break;
                case /* string provider */ 2:
                    message.provider = reader.string();
                    break;
                case /* string key_id */ 3:
                    message.keyId = reader.string();
                    break;
                case /* c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig jwk_public_key_config */ 100:
                    message.config = {
                        oneofKind: "jwkPublicKeyConfig",
                        jwkPublicKeyConfig: EncryptionConfig_JWKPublicKeyConfig.internalBinaryRead(reader, reader.uint32(), options, (message.config as any).jwkPublicKeyConfig)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EncryptionConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource principal = 1; */
        if (message.principal)
            Resource.internalBinaryWrite(message.principal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string provider = 2; */
        if (message.provider !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.provider);
        /* string key_id = 3; */
        if (message.keyId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.keyId);
        /* c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig jwk_public_key_config = 100; */
        if (message.config.oneofKind === "jwkPublicKeyConfig")
            EncryptionConfig_JWKPublicKeyConfig.internalBinaryWrite(message.config.jwkPublicKeyConfig, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.EncryptionConfig
 */
export const EncryptionConfig = new EncryptionConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EncryptionConfig_JWKPublicKeyConfig$Type extends MessageType<EncryptionConfig_JWKPublicKeyConfig> {
    constructor() {
        super("c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig", [
            { no: 1, name: "pub_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<EncryptionConfig_JWKPublicKeyConfig>): EncryptionConfig_JWKPublicKeyConfig {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pubKey = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<EncryptionConfig_JWKPublicKeyConfig>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: EncryptionConfig_JWKPublicKeyConfig): EncryptionConfig_JWKPublicKeyConfig {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes pub_key */ 1:
                    message.pubKey = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: EncryptionConfig_JWKPublicKeyConfig, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bytes pub_key = 1; */
        if (message.pubKey.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.pubKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.EncryptionConfig.JWKPublicKeyConfig
 */
export const EncryptionConfig_JWKPublicKeyConfig = new EncryptionConfig_JWKPublicKeyConfig$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceId$Type extends MessageType<ResourceId> {
    constructor() {
        super("c1.connector.v2.ResourceId", [
            { no: 1, name: "resource_type", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "resource", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 3, name: "baton_resource", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ResourceId>): ResourceId {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceType = "";
        message.resource = "";
        message.batonResource = false;
        if (value !== undefined)
            reflectionMergePartial<ResourceId>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceId): ResourceId {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string resource_type */ 1:
                    message.resourceType = reader.string();
                    break;
                case /* string resource */ 2:
                    message.resource = reader.string();
                    break;
                case /* bool baton_resource */ 3:
                    message.batonResource = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceId, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string resource_type = 1; */
        if (message.resourceType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.resourceType);
        /* string resource = 2; */
        if (message.resource !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resource);
        /* bool baton_resource = 3; */
        if (message.batonResource !== false)
            writer.tag(3, WireType.Varint).bool(message.batonResource);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceId
 */
export const ResourceId = new ResourceId$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Resource$Type extends MessageType<Resource> {
    constructor() {
        super("c1.connector.v2.Resource", [
            { no: 1, name: "id", kind: "message", T: () => ResourceId },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } },
            { no: 4, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "2048", ignoreEmpty: true } } } },
            { no: 6, name: "baton_resource", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "external_id", kind: "message", T: () => ExternalId },
            { no: 8, name: "creation_source", kind: "enum", T: () => ["c1.connector.v2.Resource.CreationSource", Resource_CreationSource, "CREATION_SOURCE_"] }
        ]);
    }
    create(value?: PartialMessage<Resource>): Resource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.annotations = [];
        message.description = "";
        message.batonResource = false;
        message.creationSource = 0;
        if (value !== undefined)
            reflectionMergePartial<Resource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Resource): Resource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.ResourceId id */ 1:
                    message.id = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* c1.connector.v2.ResourceId parent_resource_id */ 2:
                    message.parentResourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.parentResourceId);
                    break;
                case /* string display_name */ 3:
                    message.displayName = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 4:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* bool baton_resource */ 6:
                    message.batonResource = reader.bool();
                    break;
                case /* c1.connector.v2.ExternalId external_id = 7 [deprecated = true] */ 7:
                    message.externalId = ExternalId.internalBinaryRead(reader, reader.uint32(), options, message.externalId);
                    break;
                case /* c1.connector.v2.Resource.CreationSource creation_source = 8 [deprecated = true] */ 8:
                    message.creationSource = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Resource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.ResourceId id = 1; */
        if (message.id)
            ResourceId.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ResourceId parent_resource_id = 2; */
        if (message.parentResourceId)
            ResourceId.internalBinaryWrite(message.parentResourceId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 3; */
        if (message.displayName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.displayName);
        /* repeated google.protobuf.Any annotations = 4; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* bool baton_resource = 6; */
        if (message.batonResource !== false)
            writer.tag(6, WireType.Varint).bool(message.batonResource);
        /* c1.connector.v2.ExternalId external_id = 7 [deprecated = true]; */
        if (message.externalId)
            ExternalId.internalBinaryWrite(message.externalId, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.Resource.CreationSource creation_source = 8 [deprecated = true]; */
        if (message.creationSource !== 0)
            writer.tag(8, WireType.Varint).int32(message.creationSource);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.Resource
 */
export const Resource = new Resource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourcesServiceListResourcesRequest$Type extends MessageType<ResourcesServiceListResourcesRequest> {
    constructor() {
        super("c1.connector.v2.ResourcesServiceListResourcesRequest", [
            { no: 1, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024" } } } },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 250, ignoreEmpty: true } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576", ignoreEmpty: true } } } },
            { no: 5, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 6, name: "active_sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ResourcesServiceListResourcesRequest>): ResourcesServiceListResourcesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.resourceTypeId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.annotations = [];
        message.activeSyncId = "";
        if (value !== undefined)
            reflectionMergePartial<ResourcesServiceListResourcesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourcesServiceListResourcesRequest): ResourcesServiceListResourcesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string resource_type_id */ 1:
                    message.resourceTypeId = reader.string();
                    break;
                case /* c1.connector.v2.ResourceId parent_resource_id */ 2:
                    message.parentResourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.parentResourceId);
                    break;
                case /* uint32 page_size */ 3:
                    message.pageSize = reader.uint32();
                    break;
                case /* string page_token */ 4:
                    message.pageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 5:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string active_sync_id */ 6:
                    message.activeSyncId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourcesServiceListResourcesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string resource_type_id = 1; */
        if (message.resourceTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.resourceTypeId);
        /* c1.connector.v2.ResourceId parent_resource_id = 2; */
        if (message.parentResourceId)
            ResourceId.internalBinaryWrite(message.parentResourceId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* uint32 page_size = 3; */
        if (message.pageSize !== 0)
            writer.tag(3, WireType.Varint).uint32(message.pageSize);
        /* string page_token = 4; */
        if (message.pageToken !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.pageToken);
        /* repeated google.protobuf.Any annotations = 5; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string active_sync_id = 6; */
        if (message.activeSyncId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.activeSyncId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourcesServiceListResourcesRequest
 */
export const ResourcesServiceListResourcesRequest = new ResourcesServiceListResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourcesServiceListResourcesResponse$Type extends MessageType<ResourcesServiceListResourcesResponse> {
    constructor() {
        super("c1.connector.v2.ResourcesServiceListResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Resource },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1048576", ignoreEmpty: true } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ResourcesServiceListResourcesResponse>): ResourcesServiceListResourcesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<ResourcesServiceListResourcesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourcesServiceListResourcesResponse): ResourcesServiceListResourcesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.Resource list */ 1:
                    message.list.push(Resource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 3:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourcesServiceListResourcesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.Resource list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Resource.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any annotations = 3; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourcesServiceListResourcesResponse
 */
export const ResourcesServiceListResourcesResponse = new ResourcesServiceListResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceGetterServiceGetResourceRequest$Type extends MessageType<ResourceGetterServiceGetResourceRequest> {
    constructor() {
        super("c1.connector.v2.ResourceGetterServiceGetResourceRequest", [
            { no: 1, name: "resource_id", kind: "message", T: () => ResourceId },
            { no: 2, name: "parent_resource_id", kind: "message", T: () => ResourceId, options: { "validate.rules": { message: { required: false } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 4, name: "active_sync_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "1024", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<ResourceGetterServiceGetResourceRequest>): ResourceGetterServiceGetResourceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        message.activeSyncId = "";
        if (value !== undefined)
            reflectionMergePartial<ResourceGetterServiceGetResourceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceGetterServiceGetResourceRequest): ResourceGetterServiceGetResourceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.ResourceId resource_id */ 1:
                    message.resourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.resourceId);
                    break;
                case /* c1.connector.v2.ResourceId parent_resource_id */ 2:
                    message.parentResourceId = ResourceId.internalBinaryRead(reader, reader.uint32(), options, message.parentResourceId);
                    break;
                case /* repeated google.protobuf.Any annotations */ 3:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string active_sync_id */ 4:
                    message.activeSyncId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceGetterServiceGetResourceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.ResourceId resource_id = 1; */
        if (message.resourceId)
            ResourceId.internalBinaryWrite(message.resourceId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.ResourceId parent_resource_id = 2; */
        if (message.parentResourceId)
            ResourceId.internalBinaryWrite(message.parentResourceId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 3; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string active_sync_id = 4; */
        if (message.activeSyncId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.activeSyncId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceGetterServiceGetResourceRequest
 */
export const ResourceGetterServiceGetResourceRequest = new ResourceGetterServiceGetResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ResourceGetterServiceGetResourceResponse$Type extends MessageType<ResourceGetterServiceGetResourceResponse> {
    constructor() {
        super("c1.connector.v2.ResourceGetterServiceGetResourceResponse", [
            { no: 1, name: "resource", kind: "message", T: () => Resource },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ResourceGetterServiceGetResourceResponse>): ResourceGetterServiceGetResourceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<ResourceGetterServiceGetResourceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ResourceGetterServiceGetResourceResponse): ResourceGetterServiceGetResourceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Resource resource */ 1:
                    message.resource = Resource.internalBinaryRead(reader, reader.uint32(), options, message.resource);
                    break;
                case /* repeated google.protobuf.Any annotations */ 2:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ResourceGetterServiceGetResourceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Resource resource = 1; */
        if (message.resource)
            Resource.internalBinaryWrite(message.resource, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 2; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ResourceGetterServiceGetResourceResponse
 */
export const ResourceGetterServiceGetResourceResponse = new ResourceGetterServiceGetResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalId$Type extends MessageType<ExternalId> {
    constructor() {
        super("c1.connector.v2.ExternalId", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "link", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalId>): ExternalId {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.link = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalId>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalId): ExternalId {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string link */ 2:
                    message.link = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalId, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string link = 2; */
        if (message.link !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.link);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.ExternalId
 */
export const ExternalId = new ExternalId$Type();
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourceTypesService
 */
export const ResourceTypesService = new ServiceType("c1.connector.v2.ResourceTypesService", [
    { name: "ListResourceTypes", options: {}, I: ResourceTypesServiceListResourceTypesRequest, O: ResourceTypesServiceListResourceTypesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourcesService
 */
export const ResourcesService = new ServiceType("c1.connector.v2.ResourcesService", [
    { name: "ListResources", options: {}, I: ResourcesServiceListResourcesRequest, O: ResourcesServiceListResourcesResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourceGetterService
 */
export const ResourceGetterService = new ServiceType("c1.connector.v2.ResourceGetterService", [
    { name: "GetResource", options: {}, I: ResourceGetterServiceGetResourceRequest, O: ResourceGetterServiceGetResourceResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourceManagerService
 */
export const ResourceManagerService = new ServiceType("c1.connector.v2.ResourceManagerService", [
    { name: "CreateResource", options: {}, I: CreateResourceRequest, O: CreateResourceResponse },
    { name: "DeleteResource", options: {}, I: DeleteResourceRequest, O: DeleteResourceResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.ResourceDeleterService
 */
export const ResourceDeleterService = new ServiceType("c1.connector.v2.ResourceDeleterService", [
    { name: "DeleteResourceV2", options: {}, I: DeleteResourceV2Request, O: DeleteResourceV2Response }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.CredentialManagerService
 */
export const CredentialManagerService = new ServiceType("c1.connector.v2.CredentialManagerService", [
    { name: "RotateCredential", options: {}, I: RotateCredentialRequest, O: RotateCredentialResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.connector.v2.AccountManagerService
 */
export const AccountManagerService = new ServiceType("c1.connector.v2.AccountManagerService", [
    { name: "CreateAccount", options: {}, I: CreateAccountRequest, O: CreateAccountResponse }
]);
